module.exports = __webpack_public_path__ + "img/intellimat-2.1471be53.png";